import { PaymentOptionEndpoints } from '@/modules/accounting/payment-option/api/paymentOptionEndpoints'

/**
 * Payment Option endpoint instance
 * instantiate Payment Option api class with different api path
 */
export const paymentOptionEndpoints = new PaymentOptionEndpoints()
